import { EditButton, Show, SimpleShowLayout } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import ShowForm from "./Partials/ShowForm";
import CompleteMobilityDialog from "./components/CompleteMobilityDialog";

const ShowErasmusOutgoingTeachers = () => {
  return (
    <Show
      title="Детайли на заминаващ преподавател за обучение"
      actions={
        <BackButtonToolbar
          additionalButton={
            <SecuredComponent permission={permissions.canManageErasmusOutgoingTeachers}>
              <CompleteMobilityDialog />
              <EditButton
                variant="contained"
                size="medium"
              />
            </SecuredComponent>
          }
        />
      }
    >
      <SimpleShowLayout>
        <ShowForm />
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowErasmusOutgoingTeachers;
